import tw, { styled } from "twin.macro";
import { COLORS } from "../../lib/styles/styles";
import vendorImg from "../../assets/images/vendor.png";

export const Wrapper = styled.div`
	${tw`p-4 md:(pl-12 pr-12 pt-10) pb-0 `}
	.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child {
		display: none;
	}
	.hide-scrollbar {
		-ms-overflow-style: none !important; /* IE and Edge */
		scrollbar-width: none !important;
		&::-webkit-scrollbar {
			display: none !important;
		}
	}
	.ant-rate-star:not(:last-child) {
		${tw`mr-1 md:mr-2 `}
	}
`;

export const CardContainer = styled.div`
	${tw`p-0`}
	border-radius: 10px;
	background-color: ${COLORS.appGentleGray};
	${({ background }) => background && `background: url(${background});`};
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	image-rendering: pixelated !important;
	background-blend-mode: screen;
`;

export const VendorItem = styled.div`
	${tw`shadow-custom p-3 flex flex-row flex-nowrap gap-3 w-full rounded-lg hover:(shadow-lg cursor-pointer) box-border`}
	height: 10rem;
	width: 100%;
	/* max-width: 350px; */
	flex: 30%;
`;

export const BookmarkWrapper = styled.div`
	${tw`mt-0`}

	height: 70vh;
	overflow-x: hidden;
	overflow-y: scroll;

	@media (min-width: 769px) and (max-width: 1024px) {
		height: 70vh !important;
	}
	@media (max-width: 768px) {
		height: 80vh !important;
	}
`;

export const VendorItemWrapper = styled.div`
	${tw``}
	width: 100%;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	gap: 10px;
`;

export const VWrapper = styled.div`
	${tw`p-4 md:(pl-12 pr-12 pt-10) pb-0 `}

	.btnStyle {
		font-size: 0.75rem;
		font-family: "Poppins";
		border: "1px solid #f4f4f8" !important;
	}

	.delBg {
		${tw`h-9 w-9`}
		background: rgb(255, 255, 255, 0.6);
		/* border: 1px solid #ffffff; */
		box-sizing: border-box;
		border-radius: 50%;
	}
	#guest-list {
		&::placeholder {
			color: red;
			opacity: 0.6; /* Firefox */
		}
	}
	#color-picker-tool {
		background: conic-gradient(
			from 180deg at 50% 50%,
			#f15e5f 0deg,
			#ff9249 54.38deg,
			#ffb800 112.5deg,
			#00b6aa 172.5deg,
			#1877f2 240deg,
			#9895ee 316.87deg,
			#f15e5f 360deg
		);
	}
	.ant-radio-button-wrapper:not(:first-child)::before {
		display: none;
	}
	.active {
		${tw`text-appPink! text-xs font-medium shadow`}
		background: rgb(250, 115, 139, 0.2);
		font-family: Poppins;
		line-height: 12px;
		letter-spacing: 0.5px;
	}
	.inactive {
		${tw`text-appTextFaded! text-xs font-medium shadow`}
		background: rgb(175, 178, 181, 0.2);
		font-family: Poppins;
		font-style: normal;
		font-weight: 500;
		font-size: 12px;
		line-height: 12px;
		/* identical to box height, or 100% */
		letter-spacing: 0.5px;
		/* Dark */
		color: #32323284;
	}
`;

export const VendorTitle = styled.h3`
	${tw`text-white font-bold mb-0!`}
	font-size: 1.35rem;
`;

export const VendorLocation = styled.p`
	${tw`text-white`}
	font-size: 0.75rem;
`;

export const VendorAddress = styled.p`
	${tw`text-white`}
	font-size: 0.55rem;
`;

export const VendorAdvertCard = styled.div`
	position: "relative" !important;
	background: url(${vendorImg});
	height: "250px";
	/* max-height: "300px"; */
	width: "100%";
	overflow: "hidden";
`;

export const NoUpcomingWedding = styled.div`
	background: #ecf5f8;
	box-shadow: 0px 5px 50px rgba(171, 194, 235, 0.03);
	border-radius: 12px;
	box-shadow: 0px 5px 50px rgba(171, 194, 235, 0.03);
	border-radius: 12px;
`;

export const BecomeAVendorWrapper = styled.div`
	${tw`w-full p-5`}
	height: calc(100vh - 6.8rem);
	overflow-x: hidden;
	overflow-y: auto;

	@media (max-width: 769px) {
		height: calc(100vh - 5.5rem);
	}

	.label {
		${tw`text-appTextDark opacity-50 font-semibold text-lg`}
	}

	.form-control {
		${tw`pt-3 flex flex-row flex-wrap sm:flex-nowrap items-center justify-between gap-4`}
	}
	.ant-select-selection-search-input {
		padding-top: 15px !important;
	}
	.ant-select-selection-item,
	.ant-select-selection-placeholder {
		padding-top: 10px !important;
		/* color: #dedef0 !important; */
	}
	.ant-select-selection-placeholder {
		color: #db0a0a !important;
	}
	.ant-select-selector {
		${tw`shadow-sm`}
		border-radius: 12px !important;
		height: 50px !important;
		min-width: 15rem !important;
		border: 1px solid #dedef0 !important;
	}
	.ant-picker-input > input {
		padding-left: 30px;
	}
	.ant-radio {
		top: 0;
	}
	.ant-radio-wrapper {
		${tw`inline-flex items-center`}
		font-size: 12px;
		line-height: 21px;
		color: #323232;
		opacity: 0.7;

		.ant-radio-inner {
			${tw`h-6 w-6`}
			background: rgba(20, 20, 20, 0.06);
			border: 1px solid #ff5a62;
			&::after {
				content: "";
				background: #fff;
				border: 1px solid #ddd;
				display: inline-flex;
				align-items: center;
				justify-content: center;
				width: 16px;
				height: 16px;
				padding: 2px;
			}
		}
		.ant-radio-checked {
			background: #ff5a62 !important;
			border: 1px solid #ff5a62 !important;
			border-radius: 50%;
		}
	}
`;
